import { Mixins, Component } from "vue-property-decorator";
import { $t } from "@/i18n";
import { CommitableDataSlidePanel } from "@/components/slide-panel";
import CavSourcesInfo from '@/lib/models/cav-source-info';
import LabelWithHelp from '@/components/label-with-help';
import XInput from '@/components/x-input';
import { notEmpty } from '@/lib/helpers';
import CavEvtsSurface from '@/lib/models/cav-evts-surface';
import ListDropdown from '@/components/list-dropdown';
import { Getter } from 'vuex-class';
import { checkIdBdMvt } from '@/lib/services';
import { DynPanelAware } from '@/components/dyn-panel';
import DateInput from '@/components/date-input';
import DesordreSurface from '@/lib/models/desordre-surface';

@Component
export default class PanelEvtSurface extends Mixins<CommitableDataSlidePanel<CavEvtsSurface>, DynPanelAware>(CommitableDataSlidePanel, DynPanelAware) {

  @Getter getLexique;

  async created() {
    this.create && (this.data = new CavEvtsSurface());
    this.validators = [
      {fn: d => notEmpty(d.dateDebutEvt), message: "La date de l'événement est requise"},
      {fn: d => !d.idBdmvt, confirm: this.checkAndConfirmIdBdMvt}
    ];
  }

  mounted() {}

  async checkAndConfirmIdBdMvt(d): Promise<boolean> {
    const exists = await checkIdBdMvt(parseInt(d.idBdmvt));
    if (exists) {
      return true;
    } else {
      return this.promiseConfirmPanel("L'ID MVT renseigné n'existe pas. Voulez-vous continuer ?");
    }
  }

  renderHead() {
    return <span>Evénement de surface</span>
  }

  renderBody() {
    return (
      <div class="basic">
        <div class="field">
          <label class="label is-small">Événements de surface</label>
          <div class="control">
            <div class="field">
              <label class="label is-small has-text-weight-normal">Type de désordre</label>
              <div class="control">
                <ListDropdown class="basic"
                  vModel={this.data.typeDesordre}
                  data={this.getLexique(DesordreSurface)}
                  labelFn={v => v.desordresSurface}
                  transform={v => v.id}
                  prompt="-"/>
              </div>
            </div>
            <div class="field">
              <label class="label is-small has-text-weight-normal">Début de l'événement (*)</label>
              <div class="control">
                <DateInput vModel={this.data.dateDebutEvt}/>
              </div>
            </div>
            <div class="field">
              <label class="label is-small has-text-weight-normal">ID BD Mvt</label>
              <p class="control is-flex">
                <XInput vModel={this.data.idBdmvt} ofType="integer" class="input is-small"/>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-269d85ae/panel-evt-surface.tsx" });